
export function getHoliday(year, month) {
	var holidayList = new Array()
	if(1 == month) {
		holidayList = FixedEntry(year, holidayList, 1949, null, 1) // 元日

		holidayList = FixedEntry(year, holidayList, 1949, 1999, 15)
		holidayList = WdayEntry(year, holidayList, 2000, null, month, 2, 1) // 成人の日(1月第2月曜)
	}
	if(2 == month) {
		holidayList = FixedEntry(year, holidayList, 1966, null, 11) // 建国記念の日(2月11日)
		holidayList = FixedEntry(year, holidayList, 2020, null, 23)
		holidayList = FixedEntry(year, holidayList, 1989, 1989, 24)
	}
	if(3 == month) {
		holidayList = VernalEquinoxEntry(year, holidayList, 1949, null) // 春分
	}
	if(4 == month) {
		holidayList = FixedEntry(year, holidayList, 1959, 1959, 10)
		holidayList = FixedEntry(year, holidayList, 1949, null, 29) // 昭和の日(4月29日)
		holidayList = FixedEntry(year, holidayList, 2019, 2019, 30)
	}
	if(5 == month) {
		holidayList = FixedEntry(year, holidayList, 2019, 2019, 1)
		holidayList = FixedEntry(year, holidayList, 2019, 2019, 2)
		holidayList = FixedEntry(year, holidayList, 1949, null, 3) // 憲法記念日(5月3日)
		holidayList = FixedEntry(year, holidayList, 2007, null, 4) // みどりの日(5月4日)
		holidayList = FixedEntry(year, holidayList, 1949, null, 5) // こどもの日(5月5日)
	}
	if(6 == month) {
		holidayList = FixedEntry(year, holidayList, 1993, 1993, 9)
	}
	if(7 == month) {
		holidayList = FixedEntry(year, holidayList, 1996, 2002, 20)

		holidayList = WdayEntry(year, holidayList, 2003, 2019, month, 3, 1)
		holidayList = FixedEntry(year, holidayList, 2020, 2020, 23)
		holidayList = WdayEntry(year, holidayList, 2021, null, month, 3, 1) // 海の日(7月第3月曜)

		holidayList = FixedEntry(year, holidayList, 2020, 2020, 24)
	}
	if(8 == month) {
		holidayList = FixedEntry(year, holidayList, 2016, 2019,  11)
		holidayList = FixedEntry(year, holidayList, 2020, 2020,  10)
		holidayList = FixedEntry(year, holidayList, 2021, null,  11) // 山の日(8月11日)
	}
	if(9 == month) {
		holidayList = FixedEntry(year, holidayList, 1966, 2002,  15)

		if(1948 <= year) {
			var syubunDay = GetAutumnEquinoxDay(year) // 秋分
			holidayList.push(syubunDay)
			if(2003 <= year) {
				var keirouDay = GetWday(year, month, 3, 1) // 敬老の日(9月第3月曜)
				holidayList.push(keirouDay)
				if(2 == syubunDay - keirouDay) {
					holidayList.push(keirouDay + 1)
				}
			}
		}
	}
	if(10 == month) {
		holidayList = FixedEntry(year, holidayList, 1966, 1999, 10)
		holidayList = WdayEntry(year, holidayList, 2000, 2019, month, 2, 1)
		holidayList = WdayEntry(year, holidayList, 2021, null, month, 2, 1) // スポーツの日(10月第2月曜)

		holidayList = FixedEntry(year, holidayList, 2019, 2019, 22)
	}
	if(11 == month) {
		holidayList = FixedEntry(year, holidayList, 1948, null, 3) // 文化の日(11月3日)
		holidayList = FixedEntry(year, holidayList, 1990, 1990, 12)
		holidayList = FixedEntry(year, holidayList, 1948, null, 23) // 勤労感謝の日(11月23日)
	}
	if(12 == month) {
		holidayList = FixedEntry(year, holidayList, 1989, 2018, 23)
	}
	return holidayList
}

export function FixedEntry(year, holidayList, startYear, endYear, day){
	if(startYear <= year && (null == endYear || year <= endYear)) {
		holidayList.push(day)
	}
	return holidayList
}

export function GetWday(year, month, week, dayOfWeek) {
	const startDayOfWeek = new Date(year, month - 1, 1).getDay()
	if(dayOfWeek >= startDayOfWeek) {
		week -= 1
	}
	return (dayOfWeek - startDayOfWeek + 1) + week * 7
}

export function WdayEntry(year, holidayList, startYear, endYear, month, week, dayOfWeek) {
	if(startYear <= year && (null == endYear || year <= endYear)) {
		var holiday = GetWday(year, month, week, dayOfWeek)
		holidayList.push(holiday)
	}
	return holidayList
}

export function VernalEquinoxEntry(year, holidayList, startYear, endYear) {
	if(startYear <= year && (null == endYear || year <= endYear)) {
		var day = 0
		if (year < 1980) {
			day = (year >= 1960 && year % 4 == 0) ? 20 : 21
		} else {
			day = parseInt(20.8431 + 0.242194 * (year - 1980)) - parseInt((year - 1980) / 4)
		}
		holidayList.push(day)
	}
	return holidayList
}

export function GetAutumnEquinoxDay(year) {
	var day = 0
	if (year < 1980) {
		day = (year - 3) % 4 == 0 ? 24 : 23
	} else {
		day = parseInt(23.2488 + 0.242194 * (year - 1980)) - parseInt((year - 1980) / 4)
	}
	return day
}

export function getCalendarDate(start_year, last_year) {
	let result = []
	let temp = []
	for (let year = start_year; year <= last_year; year++){
		for (let month = 1; month <= 12; month++) {
			temp[year + "-" + month] = year + "年" + month + "月"
			result = {...result, ...temp}
		}
	}
	return result
}